import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Retry } from '@services/decorators/retry.decorator'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	SupplierEnrollmentNoticeQualification,
	SupplierEnrollmentNoticeQualificationSearch,
	SupplierEnrollmentNoticeQualificationOpenRequest,
	SupplierEnrollmentNoticeQualificationJudgeRequest,
	SupplierEnrollmentNoticeQualificationUndoRequest,
	SupplierEnrollmentNoticeQualificationAnswerRequest
} from '@models/supplier/notice/qualification/supplier-enrollment-notice-qualification.model'

/** Habilitação por proposta arrematada (spec 043) — `supplier-enrollment-notice-qualifications` no management. */
@Injectable({
	providedIn: 'root'
})
export class SupplierEnrollmentNoticeQualificationService extends ManagementApiBaseService<SupplierEnrollmentNoticeQualificationSearch> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.sortColumn = 'createdAt'
		this.source = 'supplier-enrollment-notice-qualifications'
		this.searchTerm = new SupplierEnrollmentNoticeQualificationSearch()
	}

	/** Iniciar Habilitação: cria a solicitação (prazo) para uma proposta ou para todas as arrematadas. */
	open(request: SupplierEnrollmentNoticeQualificationOpenRequest) {
		return this.post<SupplierEnrollmentNoticeQualificationOpenRequest, SupplierEnrollmentNoticeQualification>(`${this.source}`, request).pipe(
			map(response => new SupplierEnrollmentNoticeQualification(response))
		)
	}

	/** Julgar Habilitação: decisão única para os alvos em aberto (ou os informados). */
	judge(id: string, request: SupplierEnrollmentNoticeQualificationJudgeRequest) {
		// O `patch` do serviço base tipa a resposta como `BaseResponse`; aqui o servidor devolve a solicitação inteira.
		return this.patch<SupplierEnrollmentNoticeQualificationJudgeRequest>(`${this.source}/${id}/judge`, request).pipe(
			map(response => new SupplierEnrollmentNoticeQualification(response as unknown as Partial<SupplierEnrollmentNoticeQualification>))
		)
	}

	/** Desfazer prazo (sem alvo) ou julgamento (com alvo). */
	undo(id: string, request: SupplierEnrollmentNoticeQualificationUndoRequest = {}) {
		return this.patch<SupplierEnrollmentNoticeQualificationUndoRequest>(`${this.source}/${id}/undo`, request).pipe(
			map(response => new SupplierEnrollmentNoticeQualification(response as unknown as Partial<SupplierEnrollmentNoticeQualification>))
		)
	}

	/** Resposta do participante (portal). */
	@Retry(3)
	answer(id: string, request: SupplierEnrollmentNoticeQualificationAnswerRequest = {}) {
		return this.patch<SupplierEnrollmentNoticeQualificationAnswerRequest>(`${this.source}/${id}/answers`, request)
	}

	latest(sessionId: string, enrollmentId: string) {
		return this.get<SupplierEnrollmentNoticeQualification>(`${this.source}/latest/${sessionId}/${enrollmentId}`).pipe(
			map(response => (response ? new SupplierEnrollmentNoticeQualification(response) : null))
		)
	}

	listable(sessionId: string, enrollmentId: string) {
		return this.get<Array<SupplierEnrollmentNoticeQualification>>(`${this.source}/${sessionId}/${enrollmentId}`).pipe(
			map(response => (response ?? []).map(it => new SupplierEnrollmentNoticeQualification(it)))
		)
	}
}
